module.exports = __webpack_public_path__ + "img/share_icon.2d816bc6.png";